import axios from '@/api/axiosConfig'
import { ApiRoutes } from '../ApiRoutes'
import type { AxiosResponse } from 'axios'
import type { ApiResponse } from '@/types/apiTypes'

export type InviteSortBy = 'LastSentDate' | 'FirstName' | 'LastName' | 'Email'
export type InviteSortOrder = 'Asc' | 'Desc'
export type InviteStatus = 'Unknown' | 'Pending' | 'Redeemed' | 'Invalidated'

export interface Invite {
  inviteId: number,
  status: InviteStatus
  firstName: string | null
  lastName: string | null
  email: string | null
  phoneNumber: string | null
  phoneCountryCode: string | null
  lastSentDate: string | null
}

export interface GetInvitesRequest {
  pageNumber: number
  pageSize: number
  sortBy: InviteSortBy
  sortOrder: InviteSortOrder
  phoneNumber?: string | null
  phoneCountryCode?: string | null
  email?: string | null
  firstName?: string | null
  lastName?: string | null
  status?: InviteStatus | null
}

export interface GetInvitesResponse {
  invites: Invite[]
  totalCount: number
  pageNumber: number
  pageSize: number
}

export interface GetInviteDetailRequest {
  inviteId: number
}

export interface GetInviteDetailResponse {
  inviteId: number
  inviteCode: string
  status: InviteStatus
  lastEmailSentDate: string | null
  email: string | null
  phone: string | null
  phoneCountryCode: string | null
  phoneVerificationPin: string | null
  firstName: string | null
  lastName: string | null
  sourceApplication: string | null
  applications: string[]
}

export interface ResendInviteRequest {
  inviteId: number
}

export interface ResendInviteResponse {
  inviteId: number
  lastEmailSentDate: string | null
}

export async function getInvitesWithFilter(request: GetInvitesRequest): Promise<AxiosResponse<GetInvitesResponse>> {
  return await axios.get(ApiRoutes.Invite.GetInvitesList, {
    params: {
      PageNumber: request.pageNumber,
      PageSize: request.pageSize,
      SortBy: request.sortBy,
      SortOrder: request.sortOrder,
      PhoneNumber: request.phoneNumber,
      PhoneCountryCode: request.phoneCountryCode,
      Email: request.email,
      FirstName: request.firstName,
      LastName: request.lastName,
      Status: request.status
    }
  })
}

export async function getInviteDetail(inviteId: number): Promise<AxiosResponse<ApiResponse<GetInviteDetailResponse>>> {
  return await axios.get(ApiRoutes.Invite.GetInviteDetail, { params: { inviteId } })
}

export async function resendInvite(data: ResendInviteRequest): Promise<AxiosResponse<ApiResponse<boolean>>> {
  return await axios.post(ApiRoutes.Invite.ResendInvite, data)
}
